















































































// Importing Alert List Component
import BaseAlertList from '@/ui/BaseAlertList.vue';
// Importing input field
import BaseInputField from '@/ui/BaseInputField.vue';
// Importing variables
import {Permissions, Roles} from '@/ts/variables';

export default {
    name: 'TheFormUsers',
    components: {
        BaseAlertList,
        BaseInputField,
    },
    props: {
        user: Object,
        errors: Array,
    },
    data() {
        return {
            roles: Array(),
            permissions: Array(),
        };
    },
    methods: {},
    created() {
        this.roles = Roles;
        this.permissions = Permissions;
    },
};
